/**
 * « Mode bibliothèque » : un super admin travaille sur l'hôtel qui porte la
 * bibliothèque officielle de modèles (`is_template_source`, aujourd'hui Clarion).
 *
 * Les contrôles qui fabriquent cette bibliothèque (onglets « Templates »,
 * marquage officiel, rôles d'e-mail, mise en avant…) ne s'affichent que dans ce
 * mode : sur un hôtel client, démo comprise, un super admin voit l'écran de
 * l'hôtelier. Les modèles de groupe suivent leurs propres règles.
 *
 * Fonction pure, sans import du contexte.
 */
export function isTemplateLibraryMode(
    user: { is_super_admin?: boolean | number } | null | undefined,
    facility: { is_template_source?: boolean | number } | null | undefined,
): boolean {
    return Boolean(user?.is_super_admin) && Boolean(facility?.is_template_source);
}
